module.exports = __webpack_public_path__ + "img/avatar-angela-guzman.e9856df1.jpg";